// src/App.js
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Rutas from './Routes';
import CookiesBanner from './Components/CookiesBanner'; // Ajusta la ruta si está en otro sitio

function App() {
  return (
    <div className="App">
      <CookiesBanner />
      <Rutas />
    </div>
  );
}

export default App;
